import { render, staticRenderFns } from "./AppListView.vue?vue&type=template&id=18b5cf2e&"
import script from "./AppListView.vue?vue&type=script&lang=ts&"
export * from "./AppListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports